import React, {Suspense, useEffect} from 'react';
import {QueryClientProvider} from 'react-query';
import {queryClient} from './React-Query/queryClient';
import {ReactQueryDevtools} from 'react-query/devtools';
import './App.css';
import './main.scss';
import Layout from './Components/Layout/Layout';
import Routes from './RouteConfig/routes';
import {BrowserRouter as Router} from "react-router-dom";
import AuthProvider from './Authorization/authProvider'
import userManager, {loadUserFromStorage} from './Authorization/authService'
import store from './Store/store';
import {Provider} from 'react-redux';

function App() {
  useEffect(() => {
    // fetch current user from cookies
    loadUserFromStorage(store)
  }, [])
  return (
      // <Suspense fallback={<LoadingIndicator />}>
      <Suspense fallback="Loding...">
        <QueryClientProvider client={queryClient}>
          <Provider store={store}>
            <AuthProvider manager={userManager} store={store}>
              <Router>
                <Layout>
                  <Routes/>
                </Layout>
                {/* <Loading /> */}
              </Router>
            </AuthProvider>
          </Provider>
          <ReactQueryDevtools/>
        </QueryClientProvider>
      </Suspense>
  );
}

export default App;
